import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";
import { SERVICE_NAME } from "@zapier/utils";

export enum FolderSearchInteractionOptions {
  All = "all",
  Keyword = "keyword",
  Owner = "owner",
  OwnedByMe = "ownedByMe",
  SharedWithMe = "sharedWithMe",
  Personal = "personal",
  Shared = "shared",
}

interface EmitOptions {
  optionSelected: FolderSearchInteractionOptions;
  interactionRawText?: string;
}

export function useEmitFolderSearchInteractionEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    ({ optionSelected, interactionRawText }: EmitOptions) => {
      emitUserInteractionEvent({
        accountId,
        eventAction: "click",
        interactionName: UserInteractionName.FolderSearchInteraction,
        interactionRawText,
        optionSelected,
        systemName: SERVICE_NAME,
      });
    },
    [accountId],
  );

  return {
    emit,
  };
}
